<template>
  <form @submit.prevent>
    <CModal
        size="lg"
        :title.sync="title"
        color="info"
        :closeOnBackdrop ="false"
        :show.sync="show">


        <strong > iKids Information </strong>
            <CRow class="mt-3" v-if="!loading_info">
            <CCol >
                <Clabel>Firstname <span class="red--text"> *</span></Clabel>
                <CInput v-model="form.firstname" placeholder='First name' class="mb-1" />
              </CCol>
              <CCol >
                <Clabel>Lastname <span class="red--text"> *</span></Clabel>
                 <CInput v-model="form.lastname" placeholder='Last name' class="mb-1" />
              </CCol>
            </CRow>
            <CRow class="mt-2" v-if="!loading_info">
              <CCol >
                <Clabel>Date of Birth <span class="red--text"> *</span></Clabel>
                 <CInput v-model="form.dob" type="date"  />
              </CCol>
            </CRow>
            <CRow class="mb-3" v-if="!loading_info">
              <CCol lg="6">
                <b-form-group label="Sex">
                  <b-form-radio v-model="form.sex" name="some-radios" value="male">Male</b-form-radio>
                  <b-form-radio v-model="form.sex" name="some-radios" value="female">Female</b-form-radio>
                </b-form-group>
              </CCol>
            </CRow>
            <CRow v-else class="center"><b-spinner variant="primary" label="Spinning"><br></b-spinner></CRow>

            <strong > Parents Information </strong>
             <CRow class="mt-3" v-if="!loading_parent">
              <CCol>
                <Clabel>Dad</Clabel>
                <!-- <multiselect v-model="form.dad_id" placeholder="Select Dad" :custom-label="coachName" :options="options_dad" ></multiselect> -->

                <model-select  v-model="form.dad_people_uuid" :options="options_dad"></model-select>
                <button class="clear-button" @click="clearDad">Clear</button>

              </CCol>
              <CCol>
                <Clabel>Mom</Clabel>

                <!-- <multiselect v-model="form.mom_id" placeholder="Select Mom" :custom-label="coachName" :options="options_mom" ></multiselect> -->
                 <model-select v-model="form.mom_people_uuid" :options="options_mom"></model-select>
                 <button class="clear-button" @click="clearMom">Clear</button>
              </CCol>
              <CCol>
                <Clabel>Guardian</Clabel>

                <!-- <multiselect v-model="form.mom_id" placeholder="Select Mom" :custom-label="coachName" :options="options_mom" ></multiselect> -->
                 <model-select v-model="form.guardian_people_uuid" :options="options_guardian"></model-select>
                 <button class="clear-button" @click="clearGuardian">Clear</button>
              </CCol>
            </CRow>
            <CRow v-else class="center"><b-spinner variant="primary" label="Spinning"><br></b-spinner></CRow>

          <br>
            <strong > Class Information <span class="red--text"> *</span> </strong>
             <CRow class="mt-3" >
              <CCol>
                <b-form-select v-model="form.class_id" :options="options_class" @change="getGrade(form.class_id)"></b-form-select>
              </CCol>
            </CRow>
          <br>
            <strong > Grade </strong>
             <CRow class="mt-3" >
              <CCol>
                <b-form-select v-model="form.grade_id" :options="options_grade"></b-form-select>
              </CCol>
            </CRow>

            <!-- note section -->
            <br>
            <div v-if="mode == 'create'">
              <strong>Notes</strong>
              <CRow class="mt-3" style="display: none;">
                <CCol>
                  <Clabel>Subject</Clabel>
                  <CInput v-model="form.subject" class="mb-1" />
                </CCol>
              </CRow>
              <CRow class="mt-3" >
                <CCol>
                  <Clabel>Content</Clabel>
                  <CInput v-model="form.content" class="mb-1" />
                </CCol>
              </CRow>
            </div>
            <!-- end note section -->


            <!-- image section-->
            <br>
            <div v-if="mode == 'create'">
              <strong>Profile Picture</strong>
              <CAlert color="primary" v-if="photoKids == false">
                You can upload a photo from computer or take a picture
              </CAlert>
              <CRow class="mt-3 pl-3" >
                <b-form-file v-model="form.file" id="filePhoto" plain></b-form-file>
              </CRow>
              <CRow class="mt-3 pl-3" >
                <CButton v-if="photoKids == false" block @click="showCamera" color="warning"> Take A Photo</CButton>
                <div v-if="photoKids">
                  <CAlert color="primary">
                  You can take a photo by clicking the snap button
                </CAlert>
                <CRow>
                  <CCol sm="6">
                  </CCol>
                  <CCol>
                    <b>PREVIEW</b>
                  </CCol>
                </CRow>
                <CRow>
                  <CCol sm="6">
                    <video ref="videoElement" class="sizeVideo"  autoplay></video>
                  </CCol>
                  <CCol>
                    <img v-if="photo" class="sizePhoto" :src="photo" alt="Captured Photo">
                  </CCol>
                </CRow>
                <canvas ref="canvasElement"  hidden ></canvas>
                <CButton block @click="takePhoto"  color="warning"> <b-icon class="mr-2 mb-1" icon="camera" font-scale="1.2"></b-icon>Snap</CButton>
                </div>
              </CRow>
            </div>
            <!-- end image section -->

        <template #footer>
        <CButton @click="close()" color="danger">Cancel</CButton>
        <CButton  v-if="mode === 'create'" type="submit" v-on:click.prevent="create()"  variant="outline" color="info">Create</CButton>
        <CButton  v-if="mode === 'edit'" type="submit" v-on:click.prevent="update(form.uuid)"  variant="outline" color="info">Edit</CButton>
      </template>
    </CModal>
  </form>
</template>

<script>
import moment from 'moment';
import EventBus from '@/eventBus';
import { ModelSelect } from 'vue-search-select'
import ikid from '@/services/ikid'



export default {
name: 'keperluanmodal',
components: {ModelSelect },
  data () {
    return {
      show: false,
      loading_info: false,
      loading_parent: false,
      loading_class: false,
      loading_grade: false,
      title: '',
      mode: '',
      options_class: [],
      options_grade: [],
      options_dad: [],
      options_mom: [],
      options_guardian: [],
      form:{
        id: '',
        uuid: '',
        firstname: '',
        lastname: '',
        dob:'',
        sex:'male',
        class_id:'',
        grade_id:'',
        dad_people_uuid:'',
        mom_people_uuid:'',
        guardian_people_uuid:'',
        subject:'',
        content:'',
        file:''
      },
      options: ['Male', 'Female'],
      radioNames: ['Gender',],
      photoKids: false,
      photo: null,
    }
  },
  mounted(){

  },
  created () {
    var self = this;
    EventBus.$on('OPEN_MODAL_IKID', (params) => {
      if(params.data){
        self.show = true;
          self.title = params.title;
        self.mode = params.mode;
        self.loading_info = true;
        this.getClass() //GET SERVICE TYPE ALL FOR DROPDOWNLIST
        this.getParent() //GET PARENT ACTIVE

        ikid.getIkidbyID(params.data)
        .then(res => {


          self.form.id = res.data.id;
          self.form.uuid = res.data.uuid;
          self.form.firstname = res.data.firstname;
          self.form.lastname = res.data.lastname;
          self.form.dob = res.data.dob;
          self.form.class_id = res.data.class_id;
          self.form.grade_id = res.data.grade_id;
          self.form.sex = res.data.sex;
          self.form.dad_people_uuid = res.data.dad_people_uuid;
          self.form.mom_people_uuid = res.data.mom_people_uuid;
          self.form.guardian_people_uuid = res.data.guardian_people_uuid;
          self.loading_info = false;

          if (this.form.class_id) {
            this.getGrade(this.form.class_id); // Call getGrade with the selected class_id
          }
        }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
      }else{
        self.show = true;
        self.title = params.title;
        self.mode = params.mode;
        self.form.id = "";
        self.form.firstname = "";
        self.form.lastname = "";
        self.form.dob = "";
        self.form.sex = "male";
        self.form.class_id = "";
        self.form.grade_id = "";
        self.form.dad_people_uuid = "";
        self.form.mom_people_uuid = "";
        self.form.guardian_people_uuid = "";
        self.form.subject = "";
        self.form.content = "";

        //this.getServiceTypeOnlyActive() //GET SERVICE TYPE ONLY ACTIVE FOR DROPDOWNLIST
        this.getClass() //GET SERVICE TYPE ALL FOR DROPDOWNLIST
        this.getParent() //GET PARENT ACTIVE
      }
    });
  },

  methods: {
    open () {
      this.show = true;
    },
    close () {
      this.show = false;
      this.photoKids = false;
      this.photo = ''
    },
     coachName ({ text }) {
      return `${text}`
    },
    create(){

      this.form.dob  = moment(this.form.dob).format ('DD/MM/YYYY')

      let formData = new FormData();
      formData.append('firstname', this.form.firstname);
      formData.append('lastname', this.form.lastname);
      formData.append('dob', this.form.dob);
      formData.append('sex', this.form.sex);
      formData.append('class_id', this.form.class_id);
      formData.append('grade_id', this.form.grade_id);
      formData.append('dad_people_uuid', this.form.dad_people_uuid);
      formData.append('mom_people_uuid', this.form.mom_people_uuid);
      formData.append('guardian_people_uuid', this.form.guardian_people_uuid);
      formData.append('subject', this.form.subject);
      formData.append('content', this.form.content);
      formData.append('file', this.form.file);

      ikid.createIkid(formData)
      .then(res => {
        EventBus.$emit('TABLE_UPDATE', true)
        var params = {title: 'Success', mode:'success', data:res.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
        this.show = false;
      }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)

      })
    },
    update(id){
      this.show = false;
      this.form.dob  = moment(this.form.dob).format ('DD/MM/YYYY')
      ikid.updateIkid(id, this.form)
      .then(res => {
       EventBus.$emit('TABLE_UPDATE', true)
        var params = {title: 'Success', mode:'success', data:res.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
      }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
      })
    },
    //GET CLASS ALL FOR DROPDOWNLIST
    getClass(){
      this.loading_class = true
      this.options_class = []
      ikid.getIkidClass()
      .then(res => {
        for(let i = 0; i <= res.data.length-1; i++){
          this.options_class.push({text: res.data[i].name, value: res.data[i].id});
        }
      this.loading_class = false
      }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
      })
    },
    getGrade(class_id){
      this.loading_grade = true
      this.options_grade = []
      ikid.getIkidGrade(class_id)
      .then(res => {
        for(let i = 0; i <= res.data.length-1; i++){
          this.options_grade.push({text: res.data[i].name, value: res.data[i].id});
        }
      this.loading_grade = false
      }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
      })
    },
    // //GET CLASS ONLY ACTIVE FOR DROPDOWNLIST
    // getServiceTypeOnlyActive(){
    //   this.options = []
    //   service.getServiceTypeOnlyActive()
    //   .then(res => {
    //     for(let i = 0; i <= res.data.length-1; i++){
    //       this.options.push({text: res.data[i].name, value: res.data[i].id});
    //     }
    //   }).catch ((err) => {
    //     var params = {title: 'Error', mode:'danger', data:err.message}
    //     EventBus.$emit('OPEN_MODAL_ALERT', params)
    //   })
    // },
    //GET PARENT ACTIVE
    getParent(){
      this.loading_parent = true
      this.options_dad = []
      this.options_mom = []
      this.options_guardian = []
      ikid.getIkidParent()
      .then(res => {
        for(let i = 0; i <= res.dad.length-1; i++){
          this.options_dad.push({text: res.dad[i].firstname + ' ' + res.dad[i].lastname, value: res.dad[i].uuid});
        }
        for(let i = 0; i <= res.mom.length-1; i++){
          this.options_mom.push({text: res.mom[i].firstname + ' ' + res.mom[i].lastname, value: res.mom[i].uuid});
        }
        for(let i = 0; i <= res.guardian.length-1; i++){
          this.options_guardian.push({text: res.guardian[i].firstname + ' ' + res.guardian[i].lastname, value: res.guardian[i].uuid});
        }
        this.loading_parent = false
      }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
      })

    },
    clearDad() {
      this.form.dad_people_uuid = null; // Clear the selected item to remove the value
    },
    clearMom() {
      this.form.mom_people_uuid = null; // Clear the selected item to remove the value
    },
    clearGuardian() {
      this.form.guardian_people_uuid = null; // Clear the selected item to remove the value
    },
    showCamera(){
      this.photoKids = true,
      this.initializeCamera();
    },
    initializeCamera() {
      navigator.mediaDevices.getUserMedia({ video: true })
        .then(stream => {
          this.$refs.videoElement.srcObject = stream;
        })
        .catch(error => {
          console.error('Error accessing camera:', error);
        });
    },
    takePhoto() {
      const videoElement = this.$refs.videoElement;
      const canvasElement = this.$refs.canvasElement;

      // Set the canvas dimensions to match the video element
      canvasElement.width = videoElement.videoWidth;
      canvasElement.height = videoElement.videoHeight;

      // Draw the current frame from the video on the canvas
      canvasElement.getContext('2d').drawImage(videoElement, 0, 0, canvasElement.width, canvasElement.height);

      function dataURItoBlob(dataURI) {
      // convert base64/URLEncoded data component to raw binary data held in a string
      var byteString;
      if (dataURI.split(',')[0].indexOf('base64') >= 0)
          byteString = atob(dataURI.split(',')[1]);
      else
          byteString = unescape(dataURI.split(',')[1]);
      // separate out the mime component
      var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
      // write the bytes of the string to a typed array
      var ia = new Uint8Array(byteString.length);
      for (var i = 0; i < byteString.length; i++) {
          ia[i] = byteString.charCodeAt(i);
      }
      return new Blob([ia], {type:mimeString});
      }

      // Convert the canvas image data to a data URL
      const blob = canvasElement.toDataURL('image/png')
      const binary = dataURItoBlob(blob)
      this.photo = blob
      const myFileName = "KidsPhoto.png";
      const myFileType = "image/png";
      const file = new File([binary], myFileName,{ type: myFileType })
      this.form.file = file

    },
  }
}
</script>

<style>
.center {
    display: flex;
    align-items: center;
    justify-content: center;
}
.red--text{
  color: red;
}
.clear-button {
  background: none;
  border: none;
  color: #007bff; /* Change to your desired color */
  cursor: pointer;
}
</style>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>